import { Button } from "@/components/ui/Button";
import { Loader2, User } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CandidateSection = ({ jobId, candidates, loading,viewMode = "list" }) => {
  const navigate = useNavigate();
  const isGrid = viewMode === "grid";

  return (
    <div className="p-2 w-full space-y-1 max-h-[220px] overflow-y-auto custom-scrollbar">
      {/* Loader */}
      {loading ? (
        <div className="flex items-center gap-2 py-4 justify-center">
          <span className="w-1.5 h-1.5 rounded-full bg-purple-400 animate-bounce [animation-delay:0ms]" />
          <span className="w-1.5 h-1.5 rounded-full bg-purple-400 animate-bounce [animation-delay:150ms]" />
          <span className="w-1.5 h-1.5 rounded-full bg-purple-400 animate-bounce [animation-delay:300ms]" />
        </div>
      ) : candidates?.length > 0 ? (
        candidates.map((candidate, i) => (
          <div key={candidate.id || i} className="flex items-center justify-between w-full bg-background-tertiary/30 border border-border-primary rounded-lg px-4 py-2.5">
            {/* LEFT SECTION (FIXED) */}
            <div className="flex items-center gap-3">
              {/* Avatar */}
              <div className="hidden w-7 h-7 rounded-full bg-background-tertiary md:flex items-center justify-center">
                <User size={14} className="text-text-secondary" />
              </div>

              {/* Name + Email */}
              <div>
                <p className="text-sm text-text-primary font-medium">{candidate.name || candidate.full_name || "Unknown"}</p>
                <p className="text-xs text-text-secondary">{candidate.email || ""}</p>
              </div>
            </div>

            {/* RIGHT SECTION (FIXED) */}
            <div className="flex items-center gap-2">
              {/* Status Badge */}
              {!isGrid && candidate.status && (
                <span
                  className={`text-xs hidden md:flex px-2 py-0.5 rounded-full border ${candidate.status === "shortlisted"
                      ? "bg-status-success/10 text-status-success border-status-success/30"
                      : candidate.status === "rejected"
                        ? "bg-status-error/10 text-status-error border-status-error/30"
                        : "bg-tone-blue-soft text-tone-blue border-tone-blue/30"
                    }`}
                >
                  {candidate.status}
                </span>
              )}

              {/* Match Score */}
              {!isGrid && candidate.match_score != null && (
                <div className="text-xs hidden md:flex text-text-secondary bg-background-secondary/30 border border-border-primary px-3 py-1 rounded-full">
                  {Math.round(candidate.match_score / 10)}/10
                </div>
              )}

              {/* View Button */}
              <Button className="text-xs !px-3 !py-1 text-text-primary" onClick={() => navigate(`/admin/candidate-analysis/${candidate.id}?job_id=${jobId}`)}>
                View
              </Button>
            </div>
          </div>
        ))
      ) : (
        <p className="text-xs text-gray-400 text-center py-3">No candidates applied yet</p>
      )}
    </div>
  );
};

export default CandidateSection;
